import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiResponse } from '@domain/api';
import { ByProductItem, EndProductItem, EndProductItemAuditTrailItem, ServiceProductItem } from '@hjc/masterdata-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  private http = inject(HttpClient);

  async getByProducts() {
    return firstValueFrom(this.http.get<ApiResponse<ByProductItem[]>>('/api/byProducts'));
  }

  async getByProductById(id: string) {
    return firstValueFrom(this.http.get<ApiResponse<ByProductItem>>(`/api/byProducts/${id}`));
  }

  async getEndProducts() {
    return firstValueFrom(this.http.get<ApiResponse<EndProductItem[]>>('/api/endProducts'));
  }

  async getEndProductById(id: string) {
    return firstValueFrom(this.http.get<ApiResponse<EndProductItem>>(`/api/endProducts/${id}`));
  }

  async getEndProductAuditTrail(id: string) {
    return firstValueFrom(this.http.get<ApiResponse<EndProductItemAuditTrailItem[]>>(`/api/audit/endproduct/${id}`));
  }

  async getServices() {
    return firstValueFrom(this.http.get<ApiResponse<ServiceProductItem[]>>('/api/serviceProducts'));
  }
}
